import React from 'react';

import {grey300} from "assets/jss/main";

function IconContainer(props) {
    return (
        <div style={{
            background: grey300,
            padding: '8px',
            borderRadius: '8px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '40px',
            height: '40px',
            position: 'relative'
        }}>
            {props.children}
        </div>
    );
}

export default IconContainer;
